export const identityTypesToClear = (selection, types) =>
  selection === "passport"
    ? [types.CNI_UP, types.CNI_DOWN]
    : [types.PASSPORT];
